import React from 'react';
import { ChargeDropdownModal } from './ChargeDropdownModal';
import { Icon } from 'semantic-ui-react';

import 'semantic-ui-css/semantic.min.css';
import './ChargeDropdown.css';

interface Props {
    charge: string | undefined;
    onChange: (charge: string | undefined) => void;
    disabled?: boolean;
}
interface State {
    open: boolean;
}

export class ChargeDropdown extends React.Component<Props, State> {

    constructor(props: Props) {
        super(props);
        this.state = {
            open: false,
        };
    }

    public render() {
        const imgSrc = `https://content.worldspinner.com/heraldry/chargePreviews/${this.props.charge}.webp`;

        return <div >
            <div id="charge-dropdown-outer" style={{ opacity: this.props.disabled ? 0.5 : 1 }}
                onClick={() => { !this.props.disabled && this.setState({ open: true }) }}>
                {this.props.charge === undefined
                    ? "None"
                    : <img id="charge-dropdown-img" src={imgSrc} alt="select charge"
                    />
                }
                <Icon name="caret down" />
            </div>

            <ChargeDropdownModal open={this.state.open} onClose={() => this.setState({ open: false })}
                onChange={(charge: string | undefined) => this.onChange(charge)} />
        </div>;
    }

    private onChange(charge: string | undefined) {
        console.log("ChargeDropdown.onChange: charge= " + charge);
        this.props.onChange(charge);
        this.setState({ open: false });
    }

}
